<template>
	<div class="common bar_order">
		<div class="common-top clearfix">
			<div class="left flex flex-align-center" style="height:100%;">
				<span style="margin-left:20px;font-size:18px;">出入库记录(订单)-</span>
				<span @click="type$ement" style="font-size:14px;cursor:pointer;color: #618bfb;">点击按商品查询<i style="font-size:14px;font-weight:600;margin-left:2px;" class="iconfont icon-exchange2jiaohuan"></i></span>
			</div>
		</div>
		<div class="content-box">
			<div class="content">
				<div class="titleTable">
					<table>
	                    <tr>
	                        <th style="width:9%">序号</th>
	                        <th style="width:13%">时间</th>
	                        <th style="width:13%">类型</th>
	                        <th style="width:13%">原因</th>
	                        <!-- <th style="width:13%">总金额</th> -->
	                        <th style="width:13%">备注</th>
	                        <th style="width:13%">操作人员</th>
	                        <th style="width:13%">操作</th>
	                    </tr>
	                </table>
				</div>
                <div class="scrollBox">
                    <div class="scroll" :style="{'height':homeArr.length*10+'%'}">
                        <table class="conTable">
                            <tr v-for="(item,ind) in homeArr">
                                <td style="width:9%" v-text="ind+1+(currentPage-1)*pageSize"></td>
                                <td style="width:13%">{{item.addTime | numberToAllDate('')}}</td>
                                <td style="width:13%" v-text="stockType[item.type]"></td>
                                <td style="width:13%" v-text="sourceType[item.stockSource]"></td>
                                <!-- <td style="width:13%" v-text="item.totalAmount/100"></td> -->
                                <td style="width:13%" v-text="item.notes"  :title="item.notes"></td>
                                <td style="width:13%" v-text="item.operatorName"></td>
                                <td style="width:13%"><span style="color: #618bfb;font-size:16px;cursor:pointer;" @click="recordDetailFn(item)">详情</span></td>
                            </tr>
                        </table>
                    </div>
                </div>
                 <div class="pagers">
				    <el-pagination
				      	@current-change="handleCurrentChange"
				      	:current-page.sync="currentPage"
				      	:page-size="pageSize"
				      	layout="total, prev, pager, next,jumper"
				      	:total="total">
				    </el-pagination>
                </div>
			</div>
		</div>

		<div class="dialog-box" v-if="dialogBtn" @click="dialogBtn=false">
			<div class="dialog position-middle-center" @click.stop="" style="width:720px;">
				<span class="close-btn" @click="dialogBtn=false"><i class="iconfont icon-close-b"></i></span>
				<div class="dialog-title">出入库详情<span style="font-size:14px; margin-left:10px;font-weight:500;" v-text="'备注:'+checkDetail.notes" :title="checkDetail.notes"></span></div>
				<div class="dialog-content" style="margin-top:20px;height:400px;">
					<div class="dialog-content-title">
						<table style="width:100%;">
							<tr>
								<th style="width:10%">序号</th>
		                        <th style="width:24%">商品名称</th>
		                        <!-- <th style="width:16%">规格(个/件)</th> -->
		                        <!-- <th style="width:18%">每件进价(元/件)</th> -->
		                        <!-- <th style="width:16%" v-if="checkDetail.type=='STOCK_OUT'">出库件数(件)</th> -->
		                        <!-- <th style="width:16%" v-if="checkDetail.type=='STOCK_IN'">入库件数(件)</th> -->
		                        <th style="width:16%" v-if="checkDetail.type=='STOCK_OUT'">出库个数(个)</th>
		                        <th style="width:16%" v-if="checkDetail.type=='STOCK_IN'">入库个数(个)</th>
							</tr>
						</table>
					</div>
					<div class="dialog-scroll">
						<div class="scroll-inner">
							<table style="width:100%;text-align:center;">
								<tr v-for="(item,ind) in checkDetail.Arr">
	                                <td style="width:10%" v-text="ind+1"></td>
	                                <td style="width:24%" v-text="item.skuName"  :title="item.skuName"></td>
	                                <!-- <td style="width:16%" v-text="item.stockQuantityRatio"></td> -->
	                                <!-- <td style="width:18%" v-text="item.stockPrice/100"></td> -->
	                                <!-- <td style="width:16%" v-text="item.whole"></td> -->
	                                <td style="width:16%" v-text="item.quantity"></td>
	                            </tr>
							</table>
						</div>
					</div>
				</div>
				<!-- <div class="dialog-footer clearfix">
					<div class="footer-btn sure right" @click="billBtn = true;" v-if="checkDetail.bill">查看单据</div>
					<div class="footer-btn cancle right"  v-else>未上传单据</div>
				</div> -->
			</div>
		</div>
		<div class="dialog-box" v-if="billBtn" @click="billBtn=false">
			<div class="dialog position-middle-center" @click.stop="" style="width:600px;">
				<span class="close-btn" @click="billBtn=false"><i class="iconfont icon-close-b"></i></span>
				<div class="dialog-title">票据<span style="font-size:14px; margin-left:10px;font-weight:500;"></span></div>
				<div class="dialog-content" style="margin-top:20px;height:400px;">
					<img :src="checkDetail.bill" alt="" style="width:100%;height:100%;" v-if="checkDetail.bill">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
  	props:['storeId','config'],
  	data(){
		return {
			stockType:{
				STOCK_IN: "入库",
				STOCK_OUT: "出库"
			},
			sourceType:{
				REFUND_OUT:'退货出库',
				PURCHASE:'采购入库',
				ALLOCATION_IN:'店铺调拨',
				CHECK_IN:'盘点入库',
				STOCK_OUT_ONE:'吧台到仓库',
				CHECK_OUT:'盘点出库',
				STORAGE:'仓储（仓库至吧台）',
				REFUND:'退单入库',
				SALES:'销售出库',
				DECLINE:'吧台下架'
			},
			currentPage: 1,
	        pageSize:10,
	        total:0,
	        dialogBtn:false,
	        homeArr:[],//盘点列表
	        billBtn:false,
	        checkDetail:{
	        },//盘点详情列表
		}
	},
	watch:{
	},
	methods:{
		type$ement(){
			this.$emit('ement','_product');
		},
		//翻页
	    handleCurrentChange(val) {
	        console.log(`当前页: ${val}`);
	        this.getHomeData(val);
	    },
	    // 查看盘点详情
	    recordDetailFn(item){
	    	let obj = item;
	    	// this.$http.get('/record-details?type='+this.config+'&id='+item.id+'&storeId='+this.storeId).then((res)=>{
	    	// 	this.dialogBtn = true;
	    	// 	obj.Arr = res.data;
	    		// this.checkDetail = obj;
			// })
			console.log(item)
			this.$http({
				url:'get-receiptDetail',
				method:'GET',
				params:{
					invId:item.id,
					storeId:this.storeId
				}
				
			}).then(res=>{
				this.dialogBtn = true;
	    		obj.Arr = res.data;
	    		this.checkDetail = obj;
				// console.log(res);
			});
	    },
	    //获取首页数据
	    getHomeData(currentPage = 0){
	    	// let query = '?page='+(currentPage?currentPage-1:0)+'&size='+this.pageSize+'&storeId='+this.storeId+'&type='+this.config;
	    	// this.homeArr = [];
	    	// this.$http.get('/record'+query).then((res)=>{
	    	// 	this.homeArr = res.data.content;
	    	// 	this.total = res.data.totalElements;
			// })
	    	this.homeArr = [];
			this.$http({
				url:'get-barReceipt',
				method:'GET',
				params:{
					id:this.storeId,
					page:currentPage
				}
			}).then(res=>{
				this.homeArr = res.data;
	    		this.total = res.data.length;
			});
	    },
	   showBill(){

	   }
	},
	created () {
		this.getHomeData();
	},
	mounted() {
	},
	beforeDestroy() {
	}
}
</script>
<style lang="scss" scoped>
	@import '../../../../static/css/common.scss';
	@import "_order";
</style>


// WEBPACK FOOTER //
// src/components/bar/record/_order.vue